var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8168 10.2212C19.8287 9.53343 19.7574 8.8457 19.6069 8.17773H10.1992V11.8891H15.7227C15.5128 13.2053 14.7724 14.3752 13.6756 15.1341L13.6558 15.2566L16.6294 17.5569L16.8353 17.5767C18.724 15.8336 19.8168 13.2685 19.8168 10.2212Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1994 20.0001C12.9037 20.0001 15.1765 19.1108 16.8355 17.5772L13.6758 15.1307C12.6503 15.8184 11.4348 16.1662 10.2034 16.1306C7.60594 16.1148 5.30944 14.439 4.50171 11.9727L4.38292 11.9845L1.29057 14.3718L1.25098 14.4825C2.94563 17.8697 6.41018 20.0041 10.1994 20.0001Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.49748 11.9766C4.27971 11.3402 4.16488 10.6723 4.16488 9.9964C4.16884 9.32448 4.27971 8.65652 4.48956 8.01622L4.4856 7.88579L1.35365 5.45898L1.2507 5.50641C-0.174713 8.33242 -0.174713 11.6604 1.2507 14.4864L4.49748 11.9766Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1995 3.8661C11.6368 3.84239 13.0226 4.37597 14.0719 5.35618L16.899 2.60132C15.0855 0.90176 12.6821 -0.0270664 10.1956 0.000600781C6.40633 0.000600781 2.94178 2.13097 1.24316 5.51428L4.48202 8.02408C5.29767 5.55775 7.59813 3.88191 10.1995 3.8661Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.b2b5c4c7479c64d2245b0e5972412edc.svg";
export { ForwardRef as ReactComponent };